module.exports = __webpack_public_path__ + "static/media/right-menu-logout-icon.a537b618.svg";